"use strict";

var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var Backbone = require('dibs-backbone');
var storage = require('dibs-browser-storage');

var VisitCountModel = module.exports = Backbone.Model.extend();
var VISITS_PER_SESSION_LOGIN_PROMPT = 3;

_.extend(VisitCountModel, {
    /**
     * number of (non iframe) page views per session before login/registration auto prompt
     */
    VISITS_PER_SESSION_LOGIN_PROMPT: VISITS_PER_SESSION_LOGIN_PROMPT,

    /**
     * length of time before local storage values "expire" as session values
     * 4 hrs: (4 * 60 minutes x 60 seconds * 1000 milliseconds)
     */
    PSEUDO_SESSION_EXPIRES_AT: 14400000,

    STORAGE_KEY: 'visitCount',
    SESSION_COUNT: 'sessionCount',
    SESSION_CONTINUE: 'sessionContinue',

    /**
     * data saved on this key will "expire" when past time stamp
     */
    PSEUDO_SESSION_STORAGE_KEY: 'pseudoSessionVisitCount',

    ERROR: {
        NO_LOCAL_STORAGE: 'Local storage not available.',
        NO_SESSION_STORAGE: 'Session storage not available.'
    }
});

_.extend(VisitCountModel.prototype, {
    /**
     * any of these can be overwritten via local/session/psuedoSessionStorage
     * for A/B variant (optimizely) testing, manual QA, or unit tests
     * @returns {{totalVisitCount: number, session: number, sinceRegPrompt: number, regPromptLimit: number, pseudoSessionExpiration: number}}
     */
    defaults: function () {
        return {
            totalVisitCount: 0,
            session: 0,
            sessionCount: 0,
            sinceRegPrompt: 0,
            regPromptLimit: VisitCountModel.VISITS_PER_SESSION_LOGIN_PROMPT,
            pseudoSessionExpiration: VisitCountModel.PSEUDO_SESSION_EXPIRES_AT
        };
    },

    initialize: function (atts, options) {
        VisitCountModel.__super__.initialize.call(this, atts, options);
        if (storage && storage.localStorage) {
            this.set(this.parseIntStorageData(VisitCountModel.STORAGE_KEY, 'storage'));
            this.set(this.parseIntStorageData(VisitCountModel.PSEUDO_SESSION_STORAGE_KEY, 'storage'));
            if (this.isPseudoSessionStorageExpired()) {
                this.set('session', 0);
                this.set('regPromptLimit', this.defaults().regPromptLimit);
            }
        }
    },

    /**
     * checks to see if time stamp on "session" storage has expired
     * @returns {boolean}
     */
    isPseudoSessionStorageExpired: function () {
        //set the value "pseudoSessionExpiration" on specs or in your localStorage via the console to test expiration
        /**
         * to change expiration: run the following in the console
         ob = JSON.parse(localStorage.getItem('pseudoSessionVisitCount'));
         ob.pseudoSessionExpiration = 0;
         localStorage.setItem('pseudoSessionVisitCount', JSON.stringify(ob));
         * refresh your browser
         */
        var limit = this.get('pseudoSessionExpiration');
        var now = new Date().getTime();
        // if no timestamp assume it's brand new
        return now - (this.get('timeStamp') || now) >= limit;
    },

    /**
     * fetches an object from local storage and parses its fields to integers
     * @param key {string} the key in local storage
     * @param type {string} (optional) local or session (defaults to local)
     * @returns {mixed|*|{}}
     */
    parseIntStorageData: function (key, type) {
        var source;
        var data;
        var field;
        switch (type) {
            case 'session' :
                source = storage.sessionStorage;
                break;
            default :
                source = storage.localStorage;
                break;
        }
        data = source.getItem(key) || {};
        // parseInt over all fields
        for (field in data) {
            if (data.hasOwnProperty(field)) {
                data[field] = parseInt(data[field], 10) || 0;
            }
        }
        return data;
    },

    /**
     * increments a field by 1
     * @param {string} field
     */
    increment: function (field) {
        var val = this.get(field) || 0;
        this.set(field, val + 1);
    },

    /**
     * saves visit counts to local and session storage
     * @returns {jQuery.promise}
     */
    save: function () {

        var dfd = $.Deferred();
        var totalVisitCount = this.get('totalVisitCount');
        var sessionVisitCount = this.get('session');
        var sinceRegVisitCount = this.get('sinceRegPrompt');
        var regPromptLimit = this.get('regPromptLimit');
        var localData;
        var pseudoSessionData;

        if (!storage.localStorage) {
            return dfd.reject({msg: VisitCountModel.ERROR.NO_LOCAL_STORAGE}).promise();
        }

        localData = {
            totalVisitCount: totalVisitCount,
            sinceRegPrompt: sinceRegVisitCount,
            regPromptLimit: regPromptLimit
        };
        storage.localStorage.setItem(VisitCountModel.STORAGE_KEY, window.JSON.stringify(localData));

        pseudoSessionData = {
            session: sessionVisitCount,
            timeStamp: new Date().getTime()
        };
        storage.localStorage.setItem(VisitCountModel.PSEUDO_SESSION_STORAGE_KEY, window.JSON.stringify(pseudoSessionData));

        return dfd.resolve($.extend({msg: 'ok'}, localData, pseudoSessionData));

    },

    /**
     * removes visit counts from session and local storage
     * @returns {jQuery.promise}
     */
    destroy: function () {

        var dfd = $.Deferred();

        if (!storage.localStorage) {
            return dfd.reject({msg: VisitCountModel.ERROR.NO_LOCAL_STORAGE}).promise();
        }
        storage.localStorage.deleteItem(VisitCountModel.STORAGE_KEY);
        storage.localStorage.deleteItem(VisitCountModel.PSEUDO_SESSION_STORAGE_KEY);

        return dfd.resolve({msg: 'ok'});
    }

});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/tracking/models/VisitCountModel.js
// module id = 1432
// module chunks = 62